/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects";

import {
  LOAD_PACKAGES_LIST_RECORDS_META_DATA,
  LOAD_PACKAGES_LIST,
  LOAD_PACKAGES_SINGLE_LIST,
  LOAD_TERMS_AND_CONDITIONS_LIST,
  LOAD_TERMS_SINGLE_CONDITIONS_LIST,
  LOAD_PACKAGES_FAQ_LIST,
  LOAD_PACKAGES_FAQ_MAIN_LIST,
  LOAD_TRAVELLER_AGE_RESTRICTIONS,
  LOAD_PACKAGES_TOTAL_LIST,
  LOAD_DESTINATION_SEARCH_LIST,
} from "./constants";

import {
  loadPackagesList,
  loadPackagesListSuccess,
  loadPackagesListError,
  loadPackageListRecordsMetaDataError,
  loadPackageSingleList,
  loadPackageSingleListSuccess,
  loadPackageSingleListError,
  loadPackageListRecordsMetaDataSuccess,
  loadTermsConditionsList,
  loadTermsConditionsListSuccess,
  loadTermsConditionsListError,
  loadTermsConditionsSingleList,
  loadTermsConditionsSingleListSuccess,
  loadTermsConditionsSingleListError,
  loadPackagesFaqList,
  loadPackagesFaqListSuccess,
  loadPackagesFaqListError,
  loadPackagesFaqMainList,
  loadPackagesFaqMainListSuccess,
  loadPackagesFaqMainListError,
  loadTravellerAgeRestrictions,
  loadTravellerAgeRestrictionsSuccess,
  loadTravellerAgeRestrictionsError,
  loadPackagesTotalList,
  loadPackagesTotalListSuccess,
  loadPackagesTotalListError,
  loadDestinationSearchList,
  loadDestinationSearchListSuccess,
  loadDestinationSearchListError,
} from "./actions";

import {
  loadPackagesDetails,
  loadRecordsMetaData,
  loadPackageSingleDetails,
  loadTermsConditionsDetails,
  loadTermsConditionsSingleDetails,
  loadPackagesFaqDetails,
  loadPackagesFaqMainDetails,
  loadTravellerAgeRestrictionsDetails,
  loadPackagesTotalDetails,
  loadDestinationSearchDetails,
} from "./remotes";
import { loadDestinationList } from "../dashboard/actions";

function* loadPackagesListSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PACKAGES_LIST),
    });

    const { explicitLoad } = load;
    const { destinations } = explicitLoad || {};
    yield put(loadPackagesList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPackagesDetails, destinations);

        if (result) {
          yield put(loadPackagesListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadPackagesListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}
function* loadDestinationSearchListSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_DESTINATION_SEARCH_LIST),
    });

    const { explicitLoad } = load;
    const { destinations } = explicitLoad || {};
    yield put(loadDestinationSearchList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadDestinationSearchDetails, destinations);

        if (result) {
          yield put(loadDestinationSearchListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadDestinationSearchListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPackagesTotalListSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PACKAGES_TOTAL_LIST),
    });

    const { explicitLoad } = load;
    const { destinations } = explicitLoad || {};
    yield put(loadPackagesTotalList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPackagesTotalDetails, destinations);

        if (result) {
          yield put(loadPackagesTotalListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadPackagesTotalListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPackageSingleDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PACKAGES_SINGLE_LIST),
    });

    const { explicitLoad } = load;
    const { destinations } = explicitLoad || {};
    yield put(loadPackageSingleList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPackageSingleDetails, destinations);

        if (result) {
          yield put(loadPackageSingleListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadPackageSingleListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadTermsConditionsListSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_TERMS_AND_CONDITIONS_LIST),
    });

    const { explicitLoad } = load;
    yield put(loadTermsConditionsList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadTermsConditionsDetails);

        if (result) {
          yield put(loadTermsConditionsListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadTermsConditionsListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadTermsConditionsSingleSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_TERMS_SINGLE_CONDITIONS_LIST),
    });

    const { explicitLoad } = load;
    const { destinations } = explicitLoad || {};
    yield put(loadTermsConditionsSingleList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadTermsConditionsSingleDetails,
          destinations
        );

        if (result) {
          yield put(loadTermsConditionsSingleListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadTermsConditionsSingleListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPackagesFaqDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PACKAGES_FAQ_LIST),
    });

    const { explicitLoad } = load;
    const { destinations } = explicitLoad || {};
    yield put(loadPackagesFaqList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPackagesFaqDetails, destinations);

        if (result) {
          yield put(loadPackagesFaqListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadPackagesFaqListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}
function* loadPackagesFaqMainDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PACKAGES_FAQ_MAIN_LIST),
    });

    const { explicitLoad } = load;
    const { destinations } = explicitLoad || {};
    yield put(loadPackagesFaqMainList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPackagesFaqMainDetails, destinations);

        if (result) {
          yield put(loadPackagesFaqMainListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadPackagesFaqMainListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadTravellerAgeRestrictionsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_TRAVELLER_AGE_RESTRICTIONS),
    });

    const { explicitLoad } = load;
    const { destinations } = explicitLoad || {};
    yield put(loadTravellerAgeRestrictions(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadTravellerAgeRestrictionsDetails,
          destinations
        );

        if (result) {
          yield put(loadTravellerAgeRestrictionsSuccess(result));
        }
      } catch (error) {
        yield put(
          loadTravellerAgeRestrictionsError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPackageDetailsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_PACKAGES_LIST_RECORDS_META_DATA),
    });

    try {
      const facilityType = yield call(
        loadRecordsMetaData,
        "facilityType/get-all-data",
        "get"
      );
      const travellerAge = yield call(
        loadRecordsMetaData,
        "travellerAge/get-all-data",
        "get"
      );
      const roomType = yield call(
        loadRecordsMetaData,
        "roomType/get-all-data",
        "get"
      );

      let recordsMetaData = {
        facilityTypeOptions:
          (facilityType &&
            facilityType &&
            facilityType.length > 0 &&
            facilityType.map((c) =>
              Object.assign(
                {},
                {
                  label: c.facilityType,
                  // shortCode: c.shortCode,
                  value: c._id,
                }
              )
            )) ||
          [],
        travellerAgeOptions:
          (travellerAge &&
            travellerAge &&
            travellerAge.length > 0 &&
            travellerAge.map((c) =>
              Object.assign(
                {},
                {
                  typeName: c.ageType,
                  count: 0,
                  age: c.age,
                  matchedId: "",
                  _id: c._id,
                }
              )
            )) ||
          [],
        roomTypeOptions:
          (roomType &&
            roomType &&
            roomType.length > 0 &&
            roomType.map((c) =>
              Object.assign(
                {},
                {
                  _id: c._id,
                  label: c.roomType,
                }
              )
            )) ||
          [],
      };

      yield put(loadPackageListRecordsMetaDataSuccess(recordsMetaData));
    } catch (error) {
      yield put(
        loadPackageListRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      );
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadPackagesListSaga(),
    loadDestinationSearchListSaga(),
    loadPackagesTotalListSaga(),
    loadPackageSingleDetailsSaga(),
    loadTermsConditionsListSaga(),
    loadTermsConditionsSingleSaga(),
    loadPackagesFaqDetailsSaga(),
    loadPackagesFaqMainDetailsSaga(),
    loadPackageDetailsMetaDataSaga(),
    loadTravellerAgeRestrictionsSaga(),
  ]);
}
